import React from 'react';
import PropTypes from 'prop-types';

import RestoreIcon from '@mui/icons-material/Restore';
import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import table from '../../../../commonStyles/tables.module.css';
import tableRow from './waistMeasurements.module.css';

const WaistMeasurementRow = ({
    row,
    isDisabled,
    isDeleteDisabled,
    onEdit,
    onDelete,
    isAuditable,
    onSearchAuditItems
}) => {
    return (
        <TableRow hover className={table.basicRowStripes}>
            <TableCell>
                <div>
                    <span>{formatDate(row.measurementDate) ?? ' - '}</span>
                    {isAuditable && (
                        <span className={table.auditIcon}>
                            <RestoreIcon
                                onClick={(e) =>
                                    onSearchAuditItems(
                                        e,
                                        row.id,
                                        'Waist Measurement',
                                        'Event Date',
                                        'waist-measurement'
                                    )
                                }
                            />
                        </span>
                    )}
                </div>
            </TableCell>
            <TableCell>
                <div>
                    <span className={tableRow.alignRow}>{row.measurement}</span>
                    {isAuditable && (
                        <span className={table.auditIcon}>
                            <RestoreIcon
                                onClick={(e) =>
                                    onSearchAuditItems(
                                        e,
                                        row.id,
                                        'Waist Measurement',
                                        'Measurement',
                                        'waist-measurement'
                                    )
                                }
                            />
                        </span>
                    )}
                </div>
            </TableCell>
            <TableCell align="right">
                <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
            </TableCell>
            <TableCell align="right">
                <OnDeleteIcon onDelete={() => onDelete(row)} active={!isDeleteDisabled} />
            </TableCell>
        </TableRow>
    );
};

WaistMeasurementRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    isAuditable: PropTypes.bool,
    onSearchAuditItems: PropTypes.func
};

export default WaistMeasurementRow;
